<template>
  <div class="overflow-y-scroll">
    <auth />
    <div class="mx-auto w-full md:max-w-md mt-8">
      <local-memes class="w-full" />
    </div>
  </div>
</template>
<script>
import { getLocalMemes } from '@/gql/Queries.js';
import LocalMemes from '@ui/organisms/LocalMemes.vue';
//import AuthDialog from '@ui/organisms/AuthDialog.vue';
import Auth from '@ui/molecules/Auth.vue';
export default {
  data() {
    return {
      getLocalMemes
    }
  },
  components:{
    //AuthDialog
    Auth,
    LocalMemes
  }
}
</script>
